module.exports = __webpack_public_path__ + "assets/icons/baseline-exposure-24px-c8be.svg";